import React from 'react';
import Div from '../../Element/Div/Div';
import Flex from '../../Flex/Flex';
import Gutter from '../../Gutter/Gutter';
import Icon from '../../Icon/Icon';
import Link from '../../Link/Link';
import BodyText from '../../Typography/BodyText/BodyText';
import styles from '../LinkList.module.scss';
import { SupportedIconName } from '../../../shared/icons';

type LinkListItemProps = {
  /** Icon name shown in the item */
  iconName?: SupportedIconName;
  /** Link's destination */
  href?: string;
};
const LinkListItem: React.FunctionComponent<LinkListItemProps> = ({
  iconName,
  href: to,
  children,
}) => {
  return (
    <li className={styles.linkList_item}>
      <Link to={to} block>
        <Flex centeredVertically spaceBetween padding={{ vertical: 'sm' }}>
          <Gutter size="xlg" responsiveHidden={{ widerThan: 'md' }} />

          <Gutter responsiveHidden={{ thinnerThan: 'lg' }} />

          {iconName && <Icon name={iconName} size="md" color="black" />}

          <Gutter />

          <Div flexItem>
            <BodyText tagName="span" block>
              {children}
            </BodyText>
          </Div>

          <Gutter />

          <Icon name="arrow-right" size="sm" color="gray300" />

          <Gutter size="xlg" responsiveHidden={{ widerThan: 'md' }} />

          <Gutter responsiveHidden={{ thinnerThan: 'lg' }} />
        </Flex>
      </Link>
    </li>
  );
};

export default LinkListItem;
